import React from 'react';
import { func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field from '../../Field';

import css from './SectionContainer.module.css';
import { FormattedMessage } from 'react-intl';

import FaqSection from './FaqSection/FaqSection';
import FeaturedHomes from '../../../../components/FeaturedHomes/FeaturedHomes';
import NewListing from '../../../../components/NewListing/NewListing';
import DestinationFaq from '../../../../components/DestinationFaq/DestinationFaq';

// This component can be used to wrap some common styles and features of Section-level components.
const SectionContainer = props => {
  const {
    className,
    rootClassName,
    id,
    as,
    children,
    appearance,
    options,
    projects,
    currentUser,
    isFeaturedListing,
    onToggleFavorite,
    isAuthenticated,
    blocks,
    title,
    ...otherProps
  } = props;

  const Tag = as || 'section';
  const classes = classNames(rootClassName || css.root, className);

  return (
    <Tag className={classes} id={id} {...otherProps}>
      {appearance?.fieldType === 'customAppearance' ? (
        <Field
          data={{ alt: `Background image for ${id}`, priority: id === 'hero-section', ...appearance }}
          className={className}
          options={options}
        />
      ) : null}

      <div
        className={
          id === 'explore-world'
            ? css.exploreSection
            : id == 'invitation-section'
              ? css.invitationSection
              : id == 'value-prop'
                ? css.valuePropSection
                : id === 'destination-travel'
                  ? css.destinationTravelSection
                  : id === 'long-term-section'
                    ? css.longTermSection
                    : id == 'faq-section'
                      ? css.faqSection
                      : id === 'travling-section'
                        ? css.travlingSection
                        : id === 'memberships-section'
                          ? css.membershipSection
                          : id === 'travel-with-gfhr'
                            ? css.travelWithGfhrSection
                            : id == 'listing-slider'
                              ? css.listingSliderSectionWrapper
                              : css.sectionContent
        }
      >
        {id === 'faq-section' ? (
          <div className={css.faqWrapper}>
            <FaqSection />
          </div>
        )
          // : id === 'listing-slider' ? (<>
          //   <h1 className={css.destintaionTitle}>
          //   <FormattedMessage id="SectionContainer.featuredHeading"/>
          //   </h1>
          //   <div className={css.listingSliderSection}>
          //     <Slider {...sliderSettings}>
          //       {projects.map(l => (
          //         <div key={l.id.uuid}>
          //           <LandingPageListingCard
          //             className={css.listingCard}
          //             isAuthenticated={isAuthenticated}
          //             listing={l}
          //           />
          //         </div>
          //       ))}
          //     </Slider>
          //   </div>
          // </>
          // ) 
          : (id === 'listing-slider' && isFeaturedListing?.length > 0) ? (
            <>
              <h1 className={css.destintaionTitle}>
                <FormattedMessage id="SectionContainer.featuredHeading" />
              </h1>
              <div className={css.featuredCards}>
                <FeaturedHomes
                  projects={isFeaturedListing}
                  currentUser={currentUser}
                  onToggleFavorite={onToggleFavorite}
                />
              </div>
            </>
          )
            : (id === 'listing-slider' && isFeaturedListing?.length == 0) ? null
              : id === 'new-listing' && projects?.length > 0 ? (
                <>
                  <NewListing
                    projects={projects}
                    currentUser={currentUser}
                    onToggleFavorite={onToggleFavorite}
                  />
                </>
              ) : id === 'destination-faq' ? (
                <>
                  <DestinationFaq blocks={blocks || []} options={options} title={title} />
                </>
              ) : (
                children
              )}
      </div>
    </Tag>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionContainer.defaultProps = {
  rootClassName: null,
  className: null,
  as: 'section',
  children: null,
  appearance: null,
};

SectionContainer.propTypes = {
  rootClassName: string,
  className: string,
  as: string,
  children: node,
  appearance: object,
  options: propTypeOption,
};

export default SectionContainer;
